import React from 'react';
import {Store as StoreIcon, TrendingUp, MapPin} from 'lucide-react';
import Card from '../../../../Presentation/components/ui/Card';
import {AppSmallText, AppTitle} from '../../../../Presentation/components/ui/Typography';
import {StoreStatistics} from '../../models/store.model';

interface StoresStatisticsCardsProps {
  statistics: StoreStatistics | null;
}

export const StoresStatisticsCards: React.FC<StoresStatisticsCardsProps> = ({
  statistics
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <AppSmallText className="text-gray-600">إجمالي المتاجر</AppSmallText>
            <AppTitle className="text-gray-900">{statistics?.totalStores || 0}</AppTitle>
          </div>
          <StoreIcon className="w-8 h-8 text-brand-500" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <AppSmallText className="text-gray-600">متاجر نشطة</AppSmallText>
            <AppTitle className="text-green-600">{statistics?.activeStores || 0}</AppTitle>
          </div>
          <TrendingUp className="w-8 h-8 text-green-500" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <AppSmallText className="text-gray-600">مدفوعات معلقة</AppSmallText>
            <AppTitle className="text-orange-600">{statistics?.pendingPaymentStores || 0}</AppTitle>
          </div>
          <TrendingUp className="w-8 h-8 text-orange-500" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <AppSmallText className="text-gray-600">مخزون منخفض</AppSmallText>
            <AppTitle className="text-red-600">{(statistics?.lowStockStores || 0) + (statistics?.outOfStockStores || 0)}</AppTitle>
          </div>
          <MapPin className="w-8 h-8 text-red-500" />
        </div>
      </Card>
    </div>
  );
};
